module.exports = __webpack_public_path__ + "static/media/abs-stretch.59a3ef42.mp4";